
















import { defineComponent } from '@vue/composition-api';

import ScrollToTopButton from '@/base/app/components/atoms/ScrollToTopButton.vue';
import MyApp from '@/base/app/components/MyApp.vue';

import Course from '../components/organisms/Course.vue';

export default defineComponent({
  name: 'HomeGroupCourseContentsPage',
  components: { MyApp, Course, ScrollToTopButton },
  props: {
    id: { type: String, required: true },
    courseId: { type: String, required: true },
  },
});
